/* 我的买方接口 */

import ajax from '../ajax';
import axios from 'axios';
export default {
  // 获取我的买方列表信息
  getCrmBuyerList (params) {
    return ajax.get('/crmform/customer/crmBuyer/getCrmBuyerList.ht', params);
  },
  // 创建我的买方
  addCrmBuyer (params) {
    return axios.post(`/crmform/customer/crmBuyer/addCrmBuyer.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`, params);
  },
  // 修改我的买方
  updateCrmBuyer (params) {
    return axios.post(`/crmform/customer/crmBuyer/updateCrmBuyer.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`, params);
  },
  // 删除我的买方
  delCrmBuyer (params) {
    return ajax.get('/crmform/customer/crmBuyer/delCrmBuyer.ht', params);
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/myBuyer.js